/* Faithful App Store-style badge (black rounded button with Apple logo). */
export const AppStoreBadge = ({
  href = "#",
  className = "",
  testId = "app-store-badge-link",
  ariaLabel = "Download Clever Canine on the App Store",
}) => {
  return (
    <a
      href={href}
      data-testid={testId}
      aria-label={ariaLabel}
      className={`inline-flex items-center gap-3 rounded-xl bg-black px-4 py-2.5 text-white shadow-[0_2px_0_rgba(0,0,0,0.4),0_12px_28px_rgba(18,19,22,0.18)] transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:bg-[#111] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(var(--background))] ${className}`}
    >
      <svg
        viewBox="0 0 384 512"
        width="22"
        height="22"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zM256.4 102.3c30.4-36 27.7-68.8 26.8-80.6-26.9 1.6-58 18.4-75.7 39-19.5 22.1-31 49.4-28.5 80 29.1 2.2 55.7-12.7 77.4-38.4z" />
      </svg>
      <span className="flex flex-col items-start leading-none">
        <span className="text-[10px] font-medium text-white/85 tracking-wide">
          Download on the
        </span>
        <span className="text-lg font-semibold tracking-tight">App Store</span>
      </span>
    </a>
  );
};

export default AppStoreBadge;
